//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'
import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { DataProvider } from '../../helpers';

export class OpProtocol
    implements IReferenceType, IOpChangeState, IJsonSerializable
{
    // Properties

    public idProtocol: number
    public name: string
    public idProtocolDriver: number

    // Properties End

    // Navigation Properties

    

    // Navigation Properties End

    // Custom Properties



    // Custom Properties End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IReferenceType

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdProtocol
    }
    public getReferenceKey(): number {
        return this.idProtocol
    }
    public getReferenceValue(): any {
        return this
    }

    // IReferenceType End

    // IOpChangeState

    public opState: Enums.OpChangeState

    // IOpChangeState End

    // IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idProtocol = opObj.ID_PROTOCOL
            this.name = opObj.NAME
            this.idProtocolDriver = opObj.ID_PROTOCOL_DRIVER

            this.opState = opObj.OpState
        }
    }
    public toJSON(compressed: boolean = false): any {
        return {
            ID_PROTOCOL: this.idProtocol,
            NAME: this.name,
            ID_PROTOCOL_DRIVER: this.idProtocolDriver,

            OpState: this.opState
        }
    }

    // IJsonSerializable End

    public toString(): string {
        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpProtocol[]): JQueryPromise<OpProtocol[]> {
        const defered: JQueryDeferred<OpProtocol[]> = $.Deferred<OpProtocol[]>()

        defered.resolve(list)

        return defered.promise()
    }
}
